// Pusher Events matching RN
export const PusherEvents = {
  StaleBusyTable: 'App\\Events\\StaleBusyTable',
  TextToUser: 'App\\Events\\TextToUser',
  TextToEveryone: 'App\\Events\\TextToEveryone',
  OrderPaid: 'GromIT\\PointOfSale\\Events\\OrderPaid',
  OrderCreated: 'GromIT\\PointOfSale\\Events\\OrderCreated',
  OrderUpdated: 'GromIT\\PointOfSale\\Events\\OrderUpdated',
  UpdateOpenBill: 'App\\Events\\UpdateOpenBill',
} as const

// Pusher Event Actions for notifications
export const PusherEventActions = {
  NewOrder: 'new_order',
  ClearTable: 'clear_table',
  SetTableBusy: 'set_table_busy',
} as const

export interface IStaleBusyTablesEvent {
  payload: {
    table_id: number
    is_busy: boolean
  }
}

export interface IMessageEvent {
  payload: {
    message: string
  }
}